import {
  Alert,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { Box } from "@mui/system";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./NewPublicationDialog.module.scss";
import MainContext from "../../../context/mainContext";

interface Props {
  open: boolean;
  onContinue: () => void;
  onCancel: () => void;
}

const NewPublicationDialog: React.FC<Props> = ({ open, onContinue, onCancel }) => {
  const { currentUser } = useContext(MainContext);
  const { t } = useTranslation();
  const [exclusivePublisher, setExclusivePublisher] = useState<string>("");

  return (
    <Dialog open={open} fullWidth={true} maxWidth={"sm"} className={styles.newPublication}>
      <DialogTitle>{t("welcomeDialog", { userName: currentUser?.displayName })}</DialogTitle>
      <DialogContent>
        <FormLabel id="exclusivePublisher-group-label">{t("isIdbInvestExclusivePublisher")}</FormLabel>
        <RadioGroup
          aria-labelledby="exclusivePublisher-group-label"
          name="exclusivePublisher"
          row
          value={exclusivePublisher}
          onChange={(event) => {
            setExclusivePublisher(event.currentTarget.value);
          }}
        >
          <FormControlLabel value={"true"} control={<Radio />} label={t("yes")} />
          <FormControlLabel value={"false"} control={<Radio />} label={t("no")} />
        </RadioGroup>
        {exclusivePublisher === "false" ? (
          <>
            <Alert severity="warning" icon={false}>
              <p>{t("newPublicationWarning")}</p>
            </Alert>
            <div className={styles.moreInformation}>
              <span>{t("moreInformation")}</span>
              <p>{t("newPublicationMoreInformation")}</p>
            </div>
          </>
        ) :
          (
            <>
              <div className={styles.moreInformation}>
                <span>{t("moreInformation")}</span>
                <p className={styles.justified}>{t("newPublicationMoreInformationYes")}</p>
              </div>
            </>
          )}
        <Box>
          <Button
            className={styles.continue}
            onClick={() => {
              onContinue();
              setExclusivePublisher("");
            }}
            disabled={exclusivePublisher !== "true"}
          >
            {t("continue")}
          </Button>
          <Button
            className={styles.cancel}
            onClick={() => {
              onCancel();
              setExclusivePublisher("");
            }}
          >
            {t("cancel")}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default NewPublicationDialog;
